exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-ar-tsx": () => import("./../../../src/pages/ar.tsx" /* webpackChunkName: "component---src-pages-ar-tsx" */),
  "component---src-pages-de-tsx": () => import("./../../../src/pages/de.tsx" /* webpackChunkName: "component---src-pages-de-tsx" */),
  "component---src-pages-es-tsx": () => import("./../../../src/pages/es.tsx" /* webpackChunkName: "component---src-pages-es-tsx" */),
  "component---src-pages-fr-tsx": () => import("./../../../src/pages/fr.tsx" /* webpackChunkName: "component---src-pages-fr-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

